<template>
  <div>
    <div>
      <el-table  :data="data" ref="sortTable" @cell-mouse-enter="idEvt" :cell-style="rowStyle"
        :summary-method="getSummaries" show-summary style="width: 93%;margin-left: 170px;" class="copy"
        @sort-change="sortChangeEvt">
        <el-table-column prop="id" label="素材" width="180" align="center" sortable="custom" :sort-orders="orders"
          class-name="project_Free">
          <template slot-scope="props" style="background-color: #f00">
            <el-image :src="props.row.thumb" class="img_box" style="height: 120px;margin-top: 6px;"
              @click.stop="imgEvt()"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="average" label="平均分" width="180" align="center" sortable="custom" :sort-orders="orders">
          <template slot-scope="props">
            <span :style="{ color: props.row.average == 0 ? '#fff' : '#000' }">{{ props.row.average }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="project_name" label="项目名称" width="300" align="left" sortable="custom"
          :sort-orders="orders"></el-table-column>
        <el-table-column prop="customer_name" label="客户名称" v-if="userRole != 5 && userRole != 3 && userRole != 4"
          width="180" align="left" sortable="custom" :sort-orders="orders"></el-table-column>

        <el-table-column prop="staff" label="制作人" width="180" align="center" sortable="custom" :sort-orders="orders">
          <template slot-scope="props">
            <div style="cursor:pointer">
              <el-select v-model="props.row.staff" filterable placeholder="制作人" @change="groupChange"
                :disabled="userRole == 4">
                <el-option v-for="(item, index) in getstaff" :key="index" :label="item.name"
                  :value="item.staff_id"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="p" label="评图状态" width="180" align="center" sortable="custom" :sort-orders="orders">
          <template slot-scope="props">
            <div style="cursor:pointer">
              <el-dropdown trigger="click" @command="activeEvt">
                <span style="width:100px;display:flex;height:22px" @click="activeTextEvt(props.row)"
                  class="el-dropdown-link  white_over">
                  {{ getStatusText(props.row.p) }}

                  <i class="el-icon-caret-bottom"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :disabled="props.row.p == '未评图'" command="1">未评图</el-dropdown-item>
                  <el-dropdown-item :disabled="props.row.p == ' 评图中'" command="2"> 评图中</el-dropdown-item>
                  <el-dropdown-item :disabled="props.row.p == '已评'" command="3">已评</el-dropdown-item>
                  <el-dropdown-item :disabled="props.row.p == '无需评图'" command="4">无需评图</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>

        <el-table-column v-for="(item)  in data[0].user" width="100" :sort-orders="orders" :key="item.id"
          :prop="item.id.toString()" :label="item.realname" sortable="custom" align="center" v-if="userRole != 5">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.user.find(u => u.id === item.id).score == '0' ? '#f5f5f5' : '#000' }">
              {{ scope.row.user.find(u => u.id === item.id).score }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="userRole == 5 ? true : false">
        </el-table-column>
      </el-table>
    </div>



    <el-dialog title="" :visible.sync="searchLabelDialog" width="1300px" custom-class="searchLabel" :show-close="false"
      @close="clearValues">
      <div style="width: 100%;height: 800px;">
        <div class="image-container">
          <img :src="fullscreenImage"
            style="height:780px;width: 100%;object-fit:scale-down;background-color: #e3e3e3;" />
          <div class="prev-button" @click="prevImage"></div>
          <div class="next-button" @click="nextImage"></div>
          <div style="width: 100%;display: flex;height: 50px;justify-content: space-between;">
            <div style="display: flex;width: 500px;flex-direction: column;text-align: left;">
              <span style="font-weight: 500;width: 500px;font-size: 12px;">{{ project_name }}</span>

              <span style="width: 500px;overflow: hidden;height: 20px;font-size: 12px;margin-top: 5px;">{{
        customer_name }}</span>
            </div>
            <div style="width: 200px;font-weight: 600px;font-size: 18px;margin-top: 8px;margin-right:200px" :style="{
        color: score === '0' && average === '0' ? '#000' : '#ada7a7'
      }">{{ score }} /{{ average }}
            </div>
            <div style=" display: flex; z-index: 111;">
              <el-select v-model="staff" filterable placeholder="制作人" @change="groupChange" :disabled="userRole == 4">
                <el-option v-for="(item, index) in getstaff" :key="index" :label="item.name"
                  :value="item.staff_id"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { indexApi, GetstaffApi, StaffApi, Scoreinfo, ScoreApi, EditApi } from "@/api/design_comment/index.js"
export default {
  props: ["data", "num", "user", 'avg','staff_e'],

  data() {
    return {
      orders: ['descending', 'ascending', null],

      header: true,

      //查询数据
      checkInput: "",

      //序列前后数据
      behindOrderInput: "",
      frontOrderInput: "",
      //选择作者数据
      authorInput: "",
      //分页输入框数据
      paginationInput: 10,
      currentPage1: 1,
      //分页总数据
      total: 100,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      value2: "",
      input: "",
      tableData: [],
      userRole: null,
      num_E: null,
      selectedId: null,
      getstaff: [],

      searchLabelDialog: false,

      fullscreenImage: '',
      project_name: null,
      staff: null,
      score: null,
      average: null,
      customer_name: null,

    };
  },
  created() {
    // role字段 6管理员 3市场 4助理   5组长
    this.userRole = localStorage.getItem('role');
    this.getstaff=  this.staff_e  


    console.log(  this.getstaff,123);
    
    window.addEventListener("keydown", this.handKeyCode_o, false);
    window.addEventListener("keyup", this.handKeyEvt, true);
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode_o, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);

  },
  watch: {
    // 监听staff变化，当数据加载完成后执行相关操作
    staff_e(newVal) {
      if (newVal.length > 0) {
        // 数据加载完成后的逻辑
        this.handleStaffData(newVal);
      }
    }
  },
  mounted(){
    
  },
  methods: {
    handleStaffData(){
      this.getstaff=  this.staff_e  
    },
    getStatusText(status) {
      if (status == 1 || status == '未评图') {
        return '未评图';
      } else if (status == 2 || status == '评图中') {
        return '评图中';
      } else if (status == 3 || status == '已评') {
        return '已评';
      } else if (status == 4 || status == '无需评图') {
        return '无需评图';
      } else {
        return '';
      }
    },
    //新增
    activeTextEvt(res) {
      this.activeId = res.id;
    },
    activeEvt(res) {
      let str = "";
      this.num_E = res
      switch (this.num_E) {
        case "1":
          str = "未评图";
          break;
        case "2":
          str = "评图中";
          break;
        case "3":
          str = "已评";
          break;
        case "4":
          str = "无需评图";
          break;
      }
      EditApi({
        ids: [this.activeId],
        type: this.num_E,
      }).then((e) => {
        const updatedTableData = this.data.map((val) => {
          if (val.id == this.activeId) {
            val.p = str;
          }
          return val;
        });
        this.$emit('update-data', updatedTableData);
      });
    },

    //点击table的行的id
    idEvt(row, column, cell, event) {
      this.selectedId = row.id
    },
    imgEvt() {
      this.searchLabelDialog = true;
      // let selectedIdArray = Array.isArray(this.selectedId) ? this.selectedId : [this.selectedId];
      Scoreinfo({
        id: this.selectedId
      }).then((res) => {
        this.showFullscreen = true; //为true的时候 表示图片已经打开了
        this.fullscreenImage = res.data.url;
        this.project_name = res.data.project_name
        this.staff = res.data.staff   //名称
        this.score = res.data.score;//自己打的分
        this.average = res.data.average  //平均分
        this.customer_name = res.data.customer_name //客户名称
      })
    },


    prevImage() {
      // 找到当前selectedId在data数组中的索引
      const currentIndex = this.data.findIndex(item => item.id === this.selectedId);
      if (currentIndex > 0) {
        // 获取上一张图片的ID
        this.selectedId = this.data[currentIndex - 1].id;
        this.imgEvt();
      }
    },
    nextImage() {
      // 找到当前selectedId在data数组中的索引
      const currentIndex = this.data.findIndex(item => item.id === this.selectedId);
      if (currentIndex < this.data.length - 1) {
        // 获取下一张图片的ID
        this.selectedId = this.data[currentIndex + 1].id;
        this.imgEvt();
      }
    },
    //键盘事件
    handKeyCode_o(e) {
      e = e || window.event;
      if (this.showFullscreen) { // 如果图片打开
        // 键盘左键事件
        if (e.keyCode == 37) {
          e.preventDefault();
          this.prevImage();
        }
        //键盘右键事件
        if (e.keyCode == 39) {
          e.preventDefault();
          this.nextImage();
        }
        //按下回车切换下一页
        if (e.keyCode == 13) {
          e.preventDefault();
          this.nextImage();
        }
        //按下1 或者数字键盘1
        if (e.keyCode == 49 || e.keyCode == 97 || e.keyCode == 35) {
          let selectedIdArray = Array.isArray(this.selectedId) ? this.selectedId : [this.selectedId];
          ScoreApi({
            id: selectedIdArray,
            score: 1,
          }).then((res) => {
            if (res.code == 1000) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '500'
              });
              this.score = 1.0;
            } else {
              this.$message.error(res.msg);
            }
          })
        }
        //按下2 或者数字键盘2
        if (e.keyCode == 50 || e.keyCode == 98 || e.keyCode == 40) {
          let selectedIdArray = Array.isArray(this.selectedId) ? this.selectedId : [this.selectedId];

          ScoreApi({
            id: selectedIdArray,
            score: 2,
          }).then((res) => {
            if (res.code == 1000) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '500'
              });
              this.score = 2.0;
            } else {
              this.$message.error(res.msg);
            }
          })
        }
        //按下3 或者数字键盘3
        if (e.keyCode == 51 || e.keyCode == 99 || e.keyCode == 34) {
          let selectedIdArray = Array.isArray(this.selectedId) ? this.selectedId : [this.selectedId];

          ScoreApi({
            id: selectedIdArray,
            score: 3,
          }).then((res) => {
            if (res.code == 1000) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '500'
              });
              this.score = 3.0;
            } else {
              this.$message.error(res.msg);
            }
          })
        }
        //按下4 或者数字键盘4
        if (e.keyCode == 52 || e.keyCode == 100) {
          let selectedIdArray = Array.isArray(this.selectedId) ? this.selectedId : [this.selectedId];

          ScoreApi({
            id: selectedIdArray,
            score: 4,
          }).then((res) => {
            if (res.code == 1000) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '500'
              });
              this.score = 4.0;
            } else {
              this.$message.error(res.msg);
            }
          })
        }
        //按下5 或者数字键盘5
        if (e.keyCode == 53 || e.keyCode == 101 || e.keyCode == 12) {
          let selectedIdArray = Array.isArray(this.selectedId) ? this.selectedId : [this.selectedId];

          ScoreApi({
            id: selectedIdArray,
            score: 5,
          }).then((res) => {
            if (res.code == 1000) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '500'
              });
              this.score = 5.0;
            } else {
              this.$message.error(res.msg);
            }
          })
        }
        return;
      }
    },

    //弹窗关闭事件
    clearValues() {
      this.showFullscreen = false
    },
    modify() {
      StaffApi({
        id: this.selectedId,
        staff_id: this.staff,
      }).then((res) => {
        this.$message({
          message: res.msg,
          type: 'success'
        });
      });
    },
    //选择制作人
    groupChange(value) {
      this.staff = value;
      StaffApi({
        id: this.selectedId,
        staff_id: this.staff,
      }).then((res) => {
        this.$message({
          message: res.msg,
          type: 'success'
        });
      });
    },
    clearSort() {
      this.$refs.sortTable.clearSort();
      console.log(123);
    },
    cleanUpEvt() { },
    limitEvt() { },

    handleCurrentChange() { },
    //
    rowStyle({ row, column, rowIndex, columnIndex }) {
    },

    //列表排序
    sortChangeEvt(row) {
      this.$parent.status = '';
      let a = {
        orWhere: row.prop,
      }
      if (row.order === 'ascending') {
        a.order = 'asc';
      } else if (row.order === 'descending') {
        a.order = 'desc';
      }
      this.$emit('Min_BOX', a)
    },


    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = this.avg;
        }
        for (let key in this.user) {
          if (column.property == this.user[key].id) {
            sums[index] = this.user[key].score;
          }
        }
      });
      return sums.map(value => value === 0 ? '' : value);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-table__footer-wrapper {
  position: fixed;
  top: 145px;
  z-index: 111;
  height: 49px;
  background-color: #fff;
  width: calc(100% - 178px);
}

/deep/tbody .project_Free .cell {
  background-color: #f5f5f5 !important;
}

/deep/.el-table__header-wrapper tbody tr .project_Free {
  background: #fff !important;
}



.prev-button {
  position: absolute;
  left: 0;
  top: 0%;
  height: 800px;
  width: 300px;
  opacity: 0;
}

.prev-button:hover {
  cursor: url("../images/left.png"), auto;
}

.next-button {
  position: absolute;
  right: 0;
  top: 0%;
  height: 800px;
  width: 300px;
  opacity: 0;
}

.next-button:hover {
  cursor: url("../images/right.png"), auto;
}

@media screen and (min-width: 0px) and (max-width: 1824px) {
  .edit {
    width: 100%;
    min-width: 1200px;
    display: flex !important;
    flex-wrap: wrap;
  }

  .edit .el-input {
    width: 137px !important;
    display: block;
  }

  .span_box {
    top: 115px !important;
  }

  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: 180px !important;
    z-index: 111;
    height: 49px;
    background-color: #fff;
    width: calc(100% - 178px);
  }

  /deep/.el-table__body-wrapper {
    // overflow: auto !important;
    height: calc(100vh - 275px) !important;
  }

  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 295px) !important;
  }

  .span_box {
    height: 40px !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed {
    height: calc(100% - 16px) !important;
  }

}

@media screen and (min-width: 1825px) and (max-width: 1920px) {

  .copy {
    top: 195px !important;
    width: 91% !important;
    overflow: auto !important;
  }

  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: 185px !important;
    z-index: 111;
    height: 49px;
    background-color: #fff;
    width: calc(100% - 178px);
  }

  /deep/.el-table__body-wrapper {
    overflow-y: auto !important;
    height: calc(100vh - 290px) !important;
  }

  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 275px) !important;
  }

  .span_box {
    height: 35px !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed {
    height: calc(100% - 5px) !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 10px !important;
  }

}

@media screen and (min-width: 1921px) and (max-width: 2154px) {


  .copy {
    top: 175px !important;
    width: 93.5% !important;
    overflow: auto !important;
  }

  /deep/.el-table__body-wrapper {
    overflow: scroll !important;
    height: calc(100vh - 265px) !important;
  }

  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 255px) !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed {
    height: calc(100% - 0px) !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 10px !important;
  }
}

@media screen and (min-width: 2153px) and (max-width: 2560px) {
  .copy {
    top: 175px !important;
    width: 93.5% !important;
    overflow: auto !important;
  }

  /deep/.el-table__body-wrapper {
    overflow: scroll !important;
    height: calc(100vh - 265px) !important;
  }

  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 255px) !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed {
    height: calc(100% - 5px) !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 10px !important;
  }
}

@media screen and (min-width: 2561px) and (max-width: 3000px) {
  .copy {
    top: 175px !important;
    width: 95% !important;
    overflow: auto !important;
  }

  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: 185px !important;
    z-index: 111;
    height: 49px;
    background-color: #fff;
    width: calc(100% - 178px);
  }

  /deep/.el-table__footer-wrapper {
    top: 145px !important;
  }

  /deep/.el-table__body-wrapper {
    min-height: calc(100vh - 21vh);
    max-height: calc(100vh - 22vh);
    overflow: auto !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 337px) !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 10px !important;
  }

}

@media screen and (min-width: 3001px) and (max-width: 3440px) {
  .copy {
    top: 175px !important;
    width: 95% !important;
    overflow: auto !important;
  }

  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: 185px !important;
    z-index: 111;
    height: 49px;
    background-color: #fff;
    width: calc(100% - 178px);
  }

  /deep/.el-table__footer-wrapper {
    top: 145px !important;
  }

  /deep/.el-table__body-wrapper {
    min-height: calc(100vh - 21vh);
    max-height: calc(100vh - 22vh);
    overflow: auto !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 260px) !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 30px !important;
  }

  .content /deep/ .el-table__body-wrapper {
    min-height: calc(100vh - 55vh) !important;
    max-height: calc(100vh - 58vh) !important;
  }
}

@media screen and (min-width: 3441px) and (max-width: 3840px) {
  .copy {
    top: 175px !important;
    width: 95.5% !important;
    overflow: auto !important;
  }

  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: 185px !important;
    z-index: 111;
    height: 49px;
    background-color: #fff;
    width: calc(100% - 178px);
  }

  /deep/.el-table__footer-wrapper {
    top: 145px !important;
  }

  /deep/.el-table__body-wrapper {
    min-height: calc(100vh - 14vh);
    max-height: calc(100vh - 22vh);
    overflow: auto !important;
  }

  /deep/.el-table__fixed-body-wrapper {
    height: 100%;
    min-height: 1710px !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed {
    height: calc(100% - 16px) !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 40px !important;
  }

  .content /deep/ .el-table__body-wrapper {
    min-height: calc(100vh - 72vh) !important;
    max-height: calc(100vh - 73vh) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Work_one.vue